<template>
  <div class="screen screen__forgot_password screen__background-card">
    <div class="page--container">
      <div class="page--section">
        <el-card class="card card__login">
          <div v-show="!success">
            <header class="card__header">
            <h1 class="h2 card__title">{{$t('passwordSetTitle')}}</h1>
            <p class="card__paragraph">{{$t('passwordSetDescription')}}</p>
            </header>
            <password-set-form
              v-on:success="onSuccess">
            </password-set-form>
          </div>
          <div v-show="success">
            <header class="card__header">
              <h1 class="h2 card__title">{{$t('authenticationSuccess')}}</h1>
            </header>
            <p class="card__paragraph">
              {{$t('passwordResetSuccessMessage')}}
            </p>
            <div class="card__footer">
              <div class="card__footer_button_wrap">
                <a href="/" class="el-button el-button--primary">{{$t('passwordResetSuccessConfirmation')}}</a>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import PasswordSetForm from '@/components/PasswordSetForm.vue';
  import authentication from '@/authentication';

  export default {
    name: 'SetPassword',
    data() {
      return {
        success: null
      }
    },
    methods: {
      onSuccess() {
        this.success = true
      },
    },
    components: {
      PasswordSetForm
    }
  }
</script>

<style lang="scss" scoped>
  .card__header {
    position: relative;
  }
  .card__paragraph {
    font-size: 14px;
    margin: 0 0 10px;
  }
  .card__paragraph-emphasized {
    font-weight: bold;
    font-size: 20px;
  }
</style>
